<template>
  <div class="panel-in-tab">
    <el-tabs v-model="activeTopTab" @tab-click="handleTopTabClick" class="tabs">
      <el-tab-pane :label="item.label" v-for="item in tables" :key="item.value" :name="item.value">
        <div slot="label">
          <span>{{ item.label }}</span>
          <el-badge :value="item.number" v-if="item.number"></el-badge>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 引入内容组件 -->
    <price-content v-if="activeTopTab === 'price'" @view-details="handleViewDetails"/>
    <design-content v-else-if="activeTopTab === 'design'" @view-details="handleViewDetails"/>
    <other-content v-else-if="activeTopTab === 'other'" @view-details="handleViewDetails"/>
    <banner-content v-else-if="activeTopTab === 'banner'" @view-details="handleViewDetails"/>
  </div>
</template>

<script>
import PriceContent from './components/PriceContent.vue';
import DesignContent from './components/DesignContent.vue';
import OtherContent from './components/OtherContent.vue';
import BannerContent from './components/BannerContent.vue';

export default {
  name: 'ToBeProcessed',
  components: {
    PriceContent,
    DesignContent,
    OtherContent,
    BannerContent
  },
  props: {
    detailParams: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      activeTopTab: 'price',
      tables: [
        {
          value: 'price',
          label: '价格变更',
          number: '',
        },
        {
          value: 'design',
          label: '设计图变更',
          number: '',
        },
        {
          value: 'other',
          label: '其他信息',
          number: '',
        },
        {
          value: 'banner',
          label: '通栏图',
          number: '',
        },
      ],
    };
  },
  mounted() {},
  methods: {
    handleTopTabClick() {
      // 处理顶部标签页切换
    },
    // 处理详情点击，向父组件传递
    handleViewDetails(data) {
      this.$emit('view-details', data);
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  height 100%;
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
  >>> .el-badge
        left -4px
  >>> .el-badge__content
        background-color #f56c6c
</style>
